import axios from 'axios';
export const initLongPolling = ({ pollUrl, onPoll, retrieveAuthToken }) => {
    ;
    const pollControl = {
        updateToken: null,
        running: true,
        cancelSource: axios.CancelToken.source(),
    };
    const run = async () => {
        try {
            const url = new URL(pollUrl);
            url.searchParams.append('updateToken', pollControl.updateToken ?? '');
            const response = await axios.get(url.toString(), {
                headers: {
                    'Authorization': retrieveAuthToken === undefined ? '' : await retrieveAuthToken(),
                },
                cancelToken: pollControl.cancelSource.token
            });
            const token = response.data.updateToken;
            if (token !== pollControl.updateToken) {
                onPoll(response.data.data);
                pollControl.updateToken = token;
            }
            if (pollControl.running) {
                setTimeout(run, 1000);
            }
        }
        catch (err) {
            if (!axios.isCancel(err)) {
                // eslint-disable-next-line no-console
                console.error(err);
            }
        }
    };
    const stop = () => {
        pollControl.running = false;
        pollControl.cancelSource.cancel();
    };
    return [run, stop];
};
